<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="popupDetailsBook" v-if="popupDetailsBook" id="popup_details_book">
            <DetailsBook :bookId="params.data.id"></DetailsBook>
        </vs-popup>
    </div>
</template>

<script>
import DetailsBook from "../DetailsBook";

export default {
    name: "CellRendererActionsBook",
    components: {
        DetailsBook
    },
    data() {
        return {
            popupDetailsBook: false,
        }
    },

    methods: {
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá sách "${this.params.data.title}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/library/item/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá sách thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_BOOK', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        editRecord() {
            this.popupDetailsBook = true;
        },
    },

    mounted() {
        this.$eventBus.$on('close-popup-details-book', () => {
            this.popupDetailsBook = false;
        })
    }
}
</script>

<style lang="scss">
#popup_details_book {
    .vs-popup--header {
        display: none;
    }

    .vs-popup {
        width: 50% !important;
    }
}
</style>
